<template>
	<v-chip-group
		v-if="filtersActive.length > 0"
		class="pt-2"
		multiple
		:data-test="`${name}--filters-active`"
	>
		<v-chip
			v-for="(item, index) in filtersActive"
			:key="index"
			color="primary"
			size="small"
			:text="displayName(item)"
			closable
			@click:close="setFilterValue(name, item.definition)"
		>
		</v-chip>
	</v-chip-group>
</template>

<script setup lang="ts">
import { type Filter, useTableStateStore } from '@/stores/system/tableState.ts'
import { computed } from 'vue'
import { useTranslate } from 'composables/useTranslate.ts'

export type ActiveFilterComponentProps = {
	name: string
}

const props = defineProps<ActiveFilterComponentProps>()
const { translate } = useTranslate()
const { getFilters, setFilterValue } = useTableStateStore()

const filtersActive = computed(() => getFilters(props.name))

function displayName(item: Filter) {
	const { definition } = item

	const display = definition.value.display
	const values = item.value
	const name = translate(definition.name)

	if (Array.isArray(display)) {
		const vals: any[] = []
		display.forEach((item) => {
			if (/\w+\.\w+/.test(item)) {
				const items = item.split('.')
				vals.push(values[items[0]][items[1]])
			} else {
				vals.push(values[item])
			}
		})
		return `${name}: ${vals.join(' ')}`
	}
	if (definition.type?.startsWith('date')) {
		return `${name}: ${new Date(values).toLocaleDateString('de-DE', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		})}`
	} else {
		// Fall back to `name` when the configured display field is empty.
		// Needed e.g. for the documenttype filter where `display_label` is
		// only populated for some ERPs (Karthago) — without this, the chip
		// reads "Typ: undefined" on tenants where the field is missing.
		return `${name}: ${values[display] ?? values.name ?? ''}`
	}
}
</script>

<style></style>
